module.exports = __webpack_public_path__ + "media/images/countryrect/is-c2bcc3b458da20d2851659f4a8e755f7.svg";